import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import * as Yup from 'yup';
import { Formik } from 'formik';
import {
  Box,
  Button,
  Grid,
  TextField,
  Typography,
  Divider,
  useTheme,
} from '@mui/material';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import { apiUrl } from "../../constants";
import React, { useEffect, useState, useCallback } from 'react';
import { tokens } from "../../theme";
import axios from 'axios';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { useSelector } from 'react-redux';
import useCheckToken from '../../hooks/useCheckToken';
import useExchangeToken from "../../hooks/useExchangeToken";
import WipMasterForm from '../../components/setting/WipMasterForm';

const MySwal = withReactContent(Swal);

// === helpers ===
const isFilled = (v) => v !== '' && v !== null && v !== undefined;
const addIfFilled = (obj, key, value, asNumber = false) => {
  if (!isFilled(value)) return;
  obj[key] = asNumber ? Number(value) : value;
};

const NewMasterSTD = () => {
  const exchangeToken = useExchangeToken();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  useCheckToken();
  const ac_token = useSelector(state => state.auth.access_token);

  useEffect(() => {
    const fetchMyAPI = async () => {
      try {
        await exchangeToken();
        const id = new URL(window.location.href).searchParams.get("id");
        if (!id) return;
        const url = `${apiUrl.USER}${id}/`;
        await axios.get(url, { headers: { Authorization: `Bearer ${ac_token}` } });
      } catch (err) {
        console.error("Error fetching or exchanging token:", err);
        setError("Failed to fetch user data");
      }
    };
    fetchMyAPI();
  }, [ac_token, exchangeToken]);

  const handleRegister = useCallback(
    async (credentials, setSubmitting, setStatus) => {
      try {
        await exchangeToken();

        const plant = sessionStorage.getItem('master_std_plant') || credentials.plant_id || '';
        const factory = credentials.factory || '';
        const line = (credentials.line || '').toUpperCase().replace(/\s+/g, '');
        const sku = credentials.material_description || '';

        const body = {
          plant_id: plant,
          factory,
          line,
          material_description: sku,
          country: sessionStorage.getItem('master_std_plant') === 'B425' ? 'Vietnam' :'Thailand',
          check_on: `${plant}${factory}${line}${sku}`,
        };

        addIfFilled(body, 'belt_scale_feed_rate', credentials.belt_scale_feed_rate, true);
        addIfFilled(body, 'multihead_auto_pack', credentials.multihead_auto_pack, true);
        addIfFilled(body, 'multihead_upper_limit', credentials.multihead_upper_limit, true);
        addIfFilled(body, 'multihead_target_giveaway', credentials.multihead_target_giveaway, true);
        addIfFilled(body, 'multihead_target_pack', credentials.multihead_target_pack, true);
        addIfFilled(body, 'multihead_speed_target', credentials.multihead_speed_target, false);
        addIfFilled(body, 'multihead_df_weight', credentials.multihead_df_weight, true);

        addIfFilled(body, 'fg_std_percent_absorb_range', credentials.fg_std_percent_absorb_range, false);
        addIfFilled(body, 'fg_std_percent_meat_yield_range', credentials.fg_std_percent_meat_yield_range, false);
        addIfFilled(body, 'weight_per_piece_range', credentials.weight_per_piece_range, false);

        addIfFilled(body, 'fg_std_percent_absorb', credentials.fg_std_percent_absorb, true);
        addIfFilled(body, 'fg_std_percent_meat_yield', credentials.fg_std_percent_meat_yield, true);
        addIfFilled(body, 'fg_kg_per_box', credentials.fg_kg_per_box, true);
        addIfFilled(body, 'fg_bag_per_box', credentials.fg_bag_per_box, true);
        addIfFilled(body, 'weight_per_piece', credentials.weight_per_piece, true);

        if (isFilled(credentials.multihead_upper_limit) && isFilled(credentials.multihead_target_pack)) {
          body.multihead_upper_weight =
            Number(credentials.multihead_upper_limit) + Number(credentials.multihead_target_pack);
        }
        console.log(body)
        const res = await axios.post(`${apiUrl.POST_MASTER_STD}`, body, {
          headers: { Authorization: `Bearer ${ac_token}` },
        });

        if (res?.data?.id) {
          await MySwal.fire({
            title: 'Good job!',
            text: 'Successfully created new master std!',
            icon: 'success',
            confirmButtonText: 'Ok,Got it!',
            didOpen: () => {
              const btn = document.querySelector('.swal2-confirm');
              if (btn) { btn.style.fontFamily = 'CPF_Imm_Sook'; btn.style.fontSize = '20px'; }
            }
          });
          navigate('/list-master-std', { replace: true });
        } else {
          await MySwal.fire({
            title: 'Failed!',
            text: 'Failed to create new master std!',
            icon: 'error',
            confirmButtonText: 'Ok,Got it!',
            didOpen: () => {
              const btn = document.querySelector('.swal2-confirm');
              if (btn) { btn.style.fontFamily = 'CPF_Imm_Sook'; btn.style.fontSize = '20px'; }
            }
          });
        }
      } catch (err) {
        if (err?.response?.status === 500) {
          await MySwal.fire({
            title: 'Duplicate Entry!',
            text: 'ข้อมูลนี้มีอยู่ในระบบแล้ว กรุณาตรวจสอบอีกครั้ง',
            icon: 'warning',
            confirmButtonText: 'Ok,Got it!',
            didOpen: () => {
              const btn = document.querySelector('.swal2-confirm');
              if (btn) { btn.style.fontFamily = 'CPF_Imm_Sook'; btn.style.fontSize = '20px'; }
            }
          });
        } else {
          await MySwal.fire({
            title: 'Failed!',
            text: 'Failed to create new master std!',
            icon: 'error',
            confirmButtonText: 'Ok,Got it!',
            didOpen: () => {
              const btn = document.querySelector('.swal2-confirm');
              if (btn) { btn.style.fontFamily = 'CPF_Imm_Sook'; btn.style.fontSize = '20px'; }
            }
          });
        }
      } finally {
        setSubmitting(false);
      }
    },
    [ac_token, exchangeToken, navigate]
  );

  if (sessionStorage.getItem('master_std_plant') === '4179') return <WipMasterForm />;

  return (
    <>
      <Helmet><title>New Master STD | MES</title></Helmet>

      <Grid sx={{ backgroundColor: '#f5f5f5', paddingLeft: 10, height: '100%', width: '100%' }}>
        <Formik
          initialValues={{
            plant_id: sessionStorage.getItem('master_std_plant') || '',
            factory: sessionStorage.getItem('master_std_factory') === '1' ? '1' : sessionStorage.getItem('master_std_factory') === '00000000000001' ? '00000000000001' : '00000000000000',
            line: '',
            material_description: '',
            belt_scale_feed_rate: '',
            multihead_auto_pack: '',
            multihead_upper_limit: '',
            multihead_target_giveaway: '',
            multihead_target_pack: '',
            multihead_speed_target: '',
            multihead_df_weight: '',

            fg_std_percent_absorb_range: '',
            fg_std_percent_meat_yield_range: '',
            fg_std_percent_absorb: '',
            fg_std_percent_meat_yield: '',

            fg_kg_per_box: '',
            fg_bag_per_box: '',

            weight_per_piece_range: '',
            weight_per_piece: '',
          }}
          validationSchema={Yup.object().shape({
            line: Yup.string().max(255).required('Line is required'),
            material_description: Yup.string().max(255).required('SKU is required'),
          })}
          onSubmit={async (values, { setSubmitting, setStatus }) => {
            setSubmitting(true);
            handleRegister(values, setSubmitting, setStatus);
          }}
        >
          {({
            errors, handleBlur, handleChange, handleSubmit,
            isSubmitting, touched, values,
          }) => (
            <form onSubmit={handleSubmit}>
              <Grid item xs={12} textAlign="left" style={{ paddingTop: 20 }}>
                <Box sx={{ display: 'flex', alignItems: 'left', justifyContent: 'left' }} >
                  <Typography style={{ color: colors.neutral['black'], fontSize: 68, fontWeight: 'bold', lineHeight: "5vh" }}>
                    New Master STD&nbsp;
                  </Typography>
                </Box>
              </Grid>

              <Grid container rowSpacing={0.5} columnSpacing={{ xs: 1, sm: 0.5, md: 0.5 }} sx={{ paddingTop: 5 }} textAlign="left">
                <Grid item xs={1.5} textAlign="right" style={{ paddingTop: 0 }}>
                  <Typography style={{ color: colors.neutral['black'], fontSize: 24, lineHeight: "0vh", paddingTop: 45, paddingRight: 20 }}>
                    Plant
                  </Typography>
                </Grid>
                <Grid item xs={9} textAlign="center" style={{ paddingTop: 0 }}>
                  <TextField
                    disabled
                    fullWidth
                    label="Plant Id"
                    margin="normal"
                    name="plant_id"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.plant_id ?? ''}
                    variant="outlined"
                    size="small"
                    sx={{ "& .MuiOutlinedInput-input": { color: "#000", fontFamily: 'CPF_Imm_Sook', fontSize: 18 } }}
                  />
                </Grid>
              </Grid>

              <Grid container rowSpacing={0.5} columnSpacing={{ xs: 1, sm: 0.5, md: 0.5 }} sx={{ paddingTop: 1 }} textAlign="left">
                <Grid item xs={1.5} textAlign="right">
                  <Typography style={{ color: colors.neutral['black'], fontSize: 24, lineHeight: "0vh", paddingTop: 45, paddingRight: 20 }}>
                    Factory
                  </Typography>
                </Grid>
                <Grid item xs={9} textAlign="left" style={{ paddingTop: 0 }}>
                  <TextField
                    disabled
                    fullWidth
                    label="Factory"
                    margin="normal"
                    name="factory"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.factory ?? ''}
                    variant="outlined"
                    size="small"
                    sx={{ "& .MuiOutlinedInput-input": { color: "#000", fontFamily: 'CPF_Imm_Sook', fontSize: 18 } }}
                  />
                </Grid>
              </Grid>

              <Grid container rowSpacing={0.5} columnSpacing={{ xs: 1, sm: 0.5, md: 0.5 }} sx={{ paddingTop: 1 }} textAlign="left">
                <Grid item xs={1.5} textAlign="right">
                  <Typography style={{ color: colors.neutral['black'], fontSize: 24, lineHeight: "0vh", paddingTop: 45, paddingRight: 20 }}>
                    Line
                  </Typography>
                </Grid>
                <Grid item xs={9} textAlign="left" style={{ paddingTop: 0 }}>
                  <TextField
                    error={Boolean(touched.line && errors.line)}
                    fullWidth
                    helperText={touched.line && errors.line}
                    label="Line Number, Ex: LINE1"
                    margin="normal"
                    name="line"
                    onBlur={handleBlur}
                    onChange={(e) => {
                      const formattedValue = e.target.value
                        .toUpperCase()
                        .replace(/\s+/g, '');
                  
                      handleChange({
                        target: {
                          name: 'line',
                          value: formattedValue,
                        },
                      });
                    }}
                    value={(values.line || '').toUpperCase().replace(/\s+/g, '')}
                    variant="outlined"
                    size="small"
                    sx={{ "& .MuiOutlinedInput-input": { color: "#000", fontFamily: 'CPF_Imm_Sook', fontSize: 18 } }}
                  />
                </Grid>
              </Grid>

              <Grid container rowSpacing={0.5} columnSpacing={{ xs: 1, sm: 0.5, md: 0.5 }} sx={{ paddingTop: 1 }} textAlign="left">
                <Grid item xs={1.5} textAlign="right">
                  <Typography style={{ color: colors.neutral['black'], fontSize: 24, lineHeight: "0vh", paddingTop: 45, paddingRight: 20 }}>
                    SKU
                  </Typography>
                </Grid>
                <Grid item xs={9} textAlign="left" style={{ paddingTop: 0 }}>
                  <TextField
                    error={Boolean(touched.material_description && errors.material_description)}
                    fullWidth
                    helperText={touched.material_description && errors.material_description}
                    label="SKU(On SAP), Ex: MN-F-3034"
                    margin="normal"
                    name="material_description"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.material_description ?? ''}
                    variant="outlined"
                    size="small"
                    sx={{ "& .MuiOutlinedInput-input": { color: "#000", fontFamily: 'CPF_Imm_Sook', fontSize: 18 } }}
                  />
                </Grid>
              </Grid>

              <Grid container rowSpacing={0.5} columnSpacing={{ xs: 1, sm: 0.5, md: 0.5 }} sx={{ paddingTop: 1 }} textAlign="left">
                <Grid item xs={1.5} textAlign="right" >
                  <Typography style={{ color: colors.neutral['black'], fontSize: 24, lineHeight: "0vh", paddingTop: 45, paddingRight: 20 }} >
                    Feed rate
                  </Typography>
                </Grid>
                <Grid item xs={9} textAlign="left" style={{ paddingTop: 0 }}>
                  <TextField
                    type="number"
                    fullWidth
                    label="Production Capacity(kg/hr), Ex: 600"
                    margin="normal"
                    name="belt_scale_feed_rate"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.belt_scale_feed_rate ?? ''}
                    variant="outlined"
                    size="small"
                    sx={{ "& .MuiOutlinedInput-input": { color: "#000", fontFamily: 'CPF_Imm_Sook', fontSize: 18 } }}
                  />
                </Grid>
              </Grid>

              <Grid container rowSpacing={0.5} columnSpacing={{ xs: 1, sm: 0.5, md: 0.5 }} sx={{ paddingTop: 1 }} textAlign="left">
                <Grid item xs={1.5} />
                <Grid item xs={9} textAlign="left" style={{ paddingTop: 0 }}>
                  <TextField
                    type="number"
                    fullWidth
                    label="MTH-Std. Pack(g), Ex: 500"
                    margin="normal"
                    name="multihead_auto_pack"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.multihead_auto_pack ?? ''}
                    variant="outlined"
                    size="small"
                    sx={{ "& .MuiOutlinedInput-input": { color: "#000", fontFamily: 'CPF_Imm_Sook', fontSize: 18 } }}
                  />
                </Grid>
              </Grid>

              <Grid container rowSpacing={0.5} columnSpacing={{ xs: 1, sm: 0.5, md: 0.5 }} textAlign="left">
                <Grid item xs={1.5} />
                <Grid item xs={9}>
                  <TextField
                    type="number"
                    fullWidth
                    label="MHT-Upper Limit(g) (Std.Plus), Ex: 25"
                    margin="normal"
                    name="multihead_upper_limit"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.multihead_upper_limit ?? ''}
                    variant="outlined"
                    size="small"
                    sx={{ "& .MuiOutlinedInput-input": { color: "#000", fontFamily: 'CPF_Imm_Sook', fontSize: 18 } }}
                  />
                </Grid>
              </Grid>

              <Grid container rowSpacing={0.5} columnSpacing={{ xs: 1, sm: 0.5, md: 0.5 }} textAlign="left">
                <Grid item xs={1.5} />
                <Grid item xs={9}>
                  <TextField
                    type="number"
                    fullWidth
                    label="MTH-Target Giveaway(%), Ex: 1"
                    margin="normal"
                    name="multihead_target_giveaway"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.multihead_target_giveaway ?? ''}
                    variant="outlined"
                    size="small"
                    sx={{ "& .MuiOutlinedInput-input": { color: "#000", fontFamily: 'CPF_Imm_Sook', fontSize: 18 } }}
                  />
                </Grid>
              </Grid>

              <Grid container rowSpacing={0.5} columnSpacing={{ xs: 1, sm: 0.5, md: 0.5 }} textAlign="left">
                <Grid item xs={1.5} />
                <Grid item xs={9}>
                  <TextField
                    type="number"
                    fullWidth
                    label="MTH-Setting Pack(g), Ex: 505"
                    margin="normal"
                    name="multihead_target_pack"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.multihead_target_pack ?? ''}
                    variant="outlined"
                    size="small"
                    sx={{ "& .MuiOutlinedInput-input": { color: "#000", fontFamily: 'CPF_Imm_Sook', fontSize: 18 } }}
                  />
                </Grid>
              </Grid>

              <Grid container rowSpacing={0.5} columnSpacing={{ xs: 1, sm: 0.5, md: 0.5 }} textAlign="left">
                <Grid item xs={1.5} />
                <Grid item xs={9}>
                  <TextField
                    disabled
                    type="number"
                    fullWidth
                    label="MTH-Upper Weight = Setting Pack + Std.Plus"
                    margin="normal"
                    name="multihead_upper_weight"
                    value={
                      (Number(values.multihead_upper_limit || 0) + Number(values.multihead_target_pack || 0)) || ''
                    }
                    variant="outlined"
                    size="small"
                    sx={{ "& .MuiOutlinedInput-input": { color: "#000", fontFamily: 'CPF_Imm_Sook', fontSize: 18 } }}
                  />
                </Grid>
              </Grid>

              <Grid container rowSpacing={0.5} columnSpacing={{ xs: 1, sm: 0.5, md: 0.5 }} textAlign="left">
                <Grid item xs={1.5} />
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    label="MHT-Range Speed(Pack/min), Ex 30-40"
                    margin="normal"
                    name="multihead_speed_target"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.multihead_speed_target ?? ''}
                    variant="outlined"
                    size="small"
                    sx={{ "& .MuiOutlinedInput-input": { color: "#000", fontFamily: 'CPF_Imm_Sook', fontSize: 18 } }}
                  />
                </Grid>
              </Grid>

              <Grid container rowSpacing={0.5} columnSpacing={{ xs: 1, sm: 0.5, md: 0.5 }} textAlign="left">
                <Grid item xs={1.5} />
                <Grid item xs={9}>
                  <TextField
                    type="number"
                    fullWidth
                    label="MHT- DF Weight(g), Ex: 3000"
                    margin="normal"
                    name="multihead_df_weight"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.multihead_df_weight ?? ''}
                    variant="outlined"
                    size="small"
                    sx={{ "& .MuiOutlinedInput-input": { color: "#000", fontFamily: 'CPF_Imm_Sook', fontSize: 18 } }}
                  />
                </Grid>
              </Grid>

              <Grid container rowSpacing={0.5} columnSpacing={{ xs: 1, sm: 0.5, md: 0.5 }} textAlign="left">
                <Grid item xs={1.5} />
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    label="Absorb range(%), Ex: 70%-75%"
                    margin="normal"
                    name="fg_std_percent_absorb_range"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.fg_std_percent_absorb_range ?? ''}
                    variant="outlined"
                    size="small"
                    sx={{ "& .MuiOutlinedInput-input": { color: "#000", fontFamily: 'CPF_Imm_Sook', fontSize: 18 } }}
                  />
                </Grid>
              </Grid>

              <Grid container rowSpacing={0.5} columnSpacing={{ xs: 1, sm: 0.5, md: 0.5 }} textAlign="left">
                <Grid item xs={1.5} />
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    label="Meat yield range(%), Ex: 126-132"
                    margin="normal"
                    name="fg_std_percent_meat_yield_range"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.fg_std_percent_meat_yield_range ?? ''}
                    variant="outlined"
                    size="small"
                    sx={{ "& .MuiOutlinedInput-input": { color: "#000", fontFamily: 'CPF_Imm_Sook', fontSize: 18 } }}
                  />
                </Grid>
              </Grid>

              <Grid container rowSpacing={0.5} columnSpacing={{ xs: 1, sm: 0.5, md: 0.5 }} textAlign="left">
                <Grid item xs={1.5} />
                <Grid item xs={9}>
                  <TextField
                    type="number"
                    fullWidth
                    label="Avg. Absorb(%), Ex: 28.5"
                    margin="normal"
                    name="fg_std_percent_absorb"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.fg_std_percent_absorb ?? ''}
                    variant="outlined"
                    size="small"
                    sx={{ "& .MuiOutlinedInput-input": { color: "#000", fontFamily: 'CPF_Imm_Sook', fontSize: 18 } }}
                  />
                </Grid>
              </Grid>

              <Grid container rowSpacing={0.5} columnSpacing={{ xs: 1, sm: 0.5, md: 0.5 }} textAlign="left">
                <Grid item xs={1.5} />
                <Grid item xs={9}>
                  <TextField
                    type="number"
                    fullWidth
                    label="Avg. Meat yield(%), Ex 129"
                    margin="normal"
                    name="fg_std_percent_meat_yield"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.fg_std_percent_meat_yield ?? ''}
                    variant="outlined"
                    size="small"
                    sx={{ "& .MuiOutlinedInput-input": { color: "#000", fontFamily: 'CPF_Imm_Sook', fontSize: 18 } }}
                  />
                </Grid>
              </Grid>

              <Grid container rowSpacing={0.5} columnSpacing={{ xs: 1, sm: 0.5, md: 0.5 }} textAlign="left">
                <Grid item xs={1.5} />
                <Grid item xs={9}>
                  <TextField
                    type="number"
                    fullWidth
                    label="Box Weight(kg/Box), Ex: 10"
                    margin="normal"
                    name="fg_kg_per_box"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.fg_kg_per_box ?? ''}
                    variant="outlined"
                    size="small"
                    sx={{ "& .MuiOutlinedInput-input": { color: "#000", fontFamily: 'CPF_Imm_Sook', fontSize: 18 } }}
                  />
                </Grid>
              </Grid>

              <Grid container rowSpacing={0.5} columnSpacing={{ xs: 1, sm: 0.5, md: 0.5 }} textAlign="left">
                <Grid item xs={1.5} />
                <Grid item xs={9}>
                  <TextField
                    type="number"
                    fullWidth
                    label="Number of bags/box, Ex: 20"
                    margin="normal"
                    name="fg_bag_per_box"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.fg_bag_per_box ?? ''}
                    variant="outlined"
                    size="small"
                    sx={{ "& .MuiOutlinedInput-input": { color: "#000", fontFamily: 'CPF_Imm_Sook', fontSize: 18 } }}
                  />
                </Grid>
              </Grid>

              <Grid container rowSpacing={0.5} columnSpacing={{ xs: 1, sm: 0.5, md: 0.5 }} textAlign="left">
                <Grid item xs={1.5} />
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    label="w/pc(Range) (Ex: 23-37)"
                    margin="normal"
                    name="weight_per_piece_range"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.weight_per_piece_range ?? ''}
                    variant="outlined"
                    size="small"
                    sx={{ "& .MuiOutlinedInput-input": { color: "#000", fontFamily: 'CPF_Imm_Sook', fontSize: 18 } }}
                  />
                </Grid>
              </Grid>

              <Grid container rowSpacing={0.5} columnSpacing={{ xs: 1, sm: 0.5, md: 0.5 }} textAlign="left">
                <Grid item xs={1.5} />
                <Grid item xs={9}>
                  <TextField
                    type="number"
                    fullWidth
                    label="w/pc(Mean per piece, Ex: 30)"
                    margin="normal"
                    name="weight_per_piece"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.weight_per_piece ?? ''}
                    variant="outlined"
                    size="small"
                    sx={{ "& .MuiOutlinedInput-input": { color: "#000", fontFamily: 'CPF_Imm_Sook', fontSize: 18 } }}
                  />
                </Grid>
              </Grid>

              <Divider />

              <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 2 }}>
                <Button
                  style={{ background: '#575755', color: "white", fontSize: 18 }}
                  size="medium"
                  type="button"
                  variant="contained"
                  component={RouterLink}
                  to="/list-master-std"
                  sx={{ mr: 3 }}
                >
                  <ArrowLeftIcon />
                  Back to master std
                </Button>

                <Button
                  style={{ background: '#009688', color: "white", fontSize: 18 }}
                  disabled={isSubmitting}
                  size="medium"
                  type="submit"
                  variant="contained"
                >
                  Create new master std
                </Button>
              </Box>
            </form>
          )}
        </Formik>
      </Grid>
    </>
  );
};

export default NewMasterSTD;
